import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SettingsState } from '@states/settings/settings.reducer';

export const selectSettingsState = createFeatureSelector<SettingsState>('settingsState');

export const selectIsValid = createSelector(selectSettingsState, ({ isValid }: SettingsState) => isValid);
